import React from 'react';
import { Modal } from 'react-bootstrap';
import { AiOutlineClose } from 'react-icons/ai';

/**
 * DashModalV2 — Modern modal component aligned with the dashboard design system.
 *
 * Props:
 *   show        {boolean}   — controlled visibility
 *   onClose     {function}  — called on backdrop click or close button
 *   title       {string}    — header title
 *   subtitle    {string?}   — optional sub-line below the title
 *   size        {string}    — Bootstrap modal size: 'sm' | 'md' | 'lg' | 'xl' (default 'xl')
 *   footer      {ReactNode?}— optional footer content; if omitted only body is rendered
 *   children    {ReactNode} — modal body content
 */
const DashModalV2 = ({ show, onClose, title, subtitle, size = 'xl', footer, children }) => {
    return (
        <Modal
            show={show}
            onHide={onClose}
            size={size}
            centered
            contentClassName="dash-modal-v2-content"
        >
            {/* ── Gradient header ── */}
            <Modal.Header
                style={{
                    background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '12px 12px 0 0',
                    padding: '1.5rem 2rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                }}
            >
                <div>
                    <Modal.Title
                        style={{
                            fontFamily: "'Archivo', sans-serif",
                            fontSize: '1.25rem',
                            fontWeight: 700,
                            margin: 0,
                            color: 'white',
                        }}
                    >
                        {title}
                    </Modal.Title>
                    {subtitle && (
                        <p style={{ margin: '0.25rem 0 0', opacity: 0.85, fontSize: '0.875rem' }}>
                            {subtitle}
                        </p>
                    )}
                </div>

                <button
                    type="button"
                    onClick={onClose}
                    style={{
                        background: 'rgba(255,255,255,0.15)',
                        border: '1px solid rgba(255,255,255,0.25)',
                        borderRadius: '8px',
                        color: 'white',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '32px',
                        height: '32px',
                        fontSize: '1.125rem',
                        flexShrink: 0,
                        transition: 'background 0.2s',
                    }}
                    aria-label="Close"
                >
                    <AiOutlineClose />
                </button>
            </Modal.Header>

            {/* ── Body ── */}
            <Modal.Body
                style={{
                    padding: '1.75rem 2rem',
                    background: '#ffffff',
                }}
            >
                {children}
            </Modal.Body>

            {/* ── Footer (optional) ── */}
            {footer && (
                <Modal.Footer
                    style={{
                        padding: '1rem 2rem',
                        borderTop: '1px solid #e2e8f0',
                        background: '#ffffff',
                        borderRadius: '0 0 12px 12px',
                    }}
                >
                    {footer}
                </Modal.Footer>
            )}
        </Modal>
    );
};

export default DashModalV2;
